module.exports = __webpack_public_path__ + "img/icon_fail@3x.9b22ceaa.png";